


































import gsap from 'gsap';
import { Component, Prop, Vue } from 'vue-property-decorator';

import EventsPerPerson from './EventsPerPerson.vue';

@Component({
  components: {
    EventsPerPerson,
  },
})
export default class PeopleList extends Vue {
  @Prop()
  people: {
    name: string;
    cpf?: string;
    email: string;
    events: { name: string; alias: string; username?: string }[];
  }[];

  @Prop()
  totalEvents: { name: string; alias: string }[];

  // TRANSITION METHODS
  beforeEnter(element: HTMLLIElement) {
    element.style.opacity = '0';
    element.style.transform = 'translateY(50px)';
  }

  enter(element: HTMLLIElement, done: any) {
    gsap.to(element, {
      opacity: 1,
      y: 0,
      duration: 0.3,
      onComplete: done,
      delay: (element.dataset.index as unknown as number) * 0.1,
    });
  }
}
